class MegaMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const gNavMenu = $(".js-header-menu");
    gNavMenu.children('li').hover(function(){
      $(this).toggleClass('is-active');
      gNavMenu.toggleClass('is-active');
      if($(this).hasClass('js-has-child-menu')){
        $(this).find('ul').stop().fadeToggle();
      }
    })
  }
}